import { render, staticRenderFns } from "./StudentExamResultHistoryModal.vue?vue&type=template&id=16641e9f&scoped=true"
import script from "./StudentExamResultHistoryModal.vue?vue&type=script&lang=js"
export * from "./StudentExamResultHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./StudentExamResultHistoryModal.vue?vue&type=style&index=0&id=16641e9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16641e9f",
  null
  
)

export default component.exports